import { computed, toValue } from 'vue'

import { getUserProducts, useUserProducts } from './user-products'
import { checkUserProductPermissions } from './rule-based-access'

export function useSectionAccess(rule) {
  const userProducts = useUserProducts()
  return computed(() => checkUserProductPermissions(userProducts.value, toValue(rule)))
}

export async function evaluateAsyncSectionAccess(rule) {
  const userProducts = await getUserProducts()
  return checkUserProductPermissions(userProducts, toValue(rule))
}
